// クライアント JS のエントリ。機能の import と初期化順を管理する。

import { alignHashTarget, inViewAnm, lenisPageScroll } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu } from './libs/Header';
import { addAutoFunc, confirmForm } from './libs/Form';
import { accordionFunc } from './libs/Accordion';
import { archiveDropdown } from './libs/Dropdown';
import { slider } from './libs/Slider';
import { tabFunc } from './libs/Tab';
import { productGallery } from './libs/ProductGallery';

window.addEventListener('DOMContentLoaded', () => {
  fixedHeader();
  drawer();
  megaMenu();
  addAutoFunc();
  lenisPageScroll();
  confirmForm();
  accordionFunc();
  archiveDropdown();
  // Splide は初期化まで .splide を非表示にするため、load ではなくここで初期化する
  slider();
  tabFunc();
  productGallery();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  inViewAnm();
  // 入場アニメーションの初期化後に、#anchor 付きで来たときの着地位置を確定させる
  alignHashTarget();
});
